/**
 * Default gene symbols for known-disease validation (instance + feature checks).
 * Keep in sync with backend AD_GENE_LIST in services/omics_analysis.py.
 */
export const DEFAULT_KNOWN_AD_GENES = [
  'APOE', 'APP', 'PSEN1', 'PSEN2', 'INPP5D',
  'CASS4', 'NME8', 'MEF2C', 'PTK2B', 'FERMT2',
  'ZCWPW1', 'DSG2', 'UNC5C', 'ADAM10', 'SLC24A4',
  'RIN3', 'HLA-DRB5', 'HLA-DRB1',
];

const MAX_GENES = 200;

/**
 * Parse textarea input into unique uppercase gene symbols.
 */
export function parseKnownAdGenesInput(text) {
  if (!text || !String(text).trim()) return [];
  const parts = String(text)
    .split(/[\s,;\n]+/)
    .map((s) => s.trim().toUpperCase())
    .filter((s) => s.length > 0 && s.length <= 64);
  return [...new Set(parts)].slice(0, MAX_GENES);
}
